import { api } from './api';
import { AudioFeatures } from '@meradio/shared-types';

export interface ArtistVideo {
  id: string;
  videoId: string;
  channelId?: string;
  title: string;
  description?: string;
  thumbnailUrl?: string;
  publishedAt: string;
  parsedAlbum?: string | null;
  isLiked?: boolean;
  audioFeatures?: AudioFeatures | null;
  channel?: {
    id?: string;
    channelId?: string;
    name?: string;
    thumbnailUrl?: string;
  };
}

export const getVideosByArtist = async (name: string): Promise<ArtistVideo[]> => {
  if (!name || name.trim().length === 0) {
    throw new Error('Artist name is required');
  }

  const response = await api.get<ArtistVideo[]>(`/videos/by-artist/${encodeURIComponent(name)}`);

  if (!response.success) {
    throw new Error(response.error || 'Failed to get videos by artist');
  }

  return response.data ?? [];
};

export const getVideosByAlbum = async (name: string): Promise<ArtistVideo[]> => {
  if (!name || name.trim().length === 0) {
    throw new Error('Album name is required');
  }

  const response = await api.get<ArtistVideo[]>(`/videos/by-album/${encodeURIComponent(name)}`);

  if (!response.success) {
    throw new Error(response.error || 'Failed to get videos by album');
  }

  return response.data ?? [];
};
